import { useField } from "formik";
import {
  SelectFormik,
  TextInputFormik,
  useGetCountriesOptions,
  useGetStatsProvincesByCountryOptions,
  Spinner,
} from "component-library";
import { useTranslation } from "i18n";
import { COUNTRIES_WITH_STATE_PROVINCE, FieldNames } from "./constants";

const BillingAddressFormBlock = () => {
  const { t } = useTranslation();
  const [field] = useField<string>(FieldNames.AccountCountry);
  const { countries, isLoading } = useGetCountriesOptions({
    shouldIncludeStates: true,
  });
  const stateOptions = useGetStatsProvincesByCountryOptions(field.value);
  const isRequiredProvince = COUNTRIES_WITH_STATE_PROVINCE.includes(
    field.value
  );

  if (isLoading) return <Spinner inline />;

  return (
    <>
      <TextInputFormik
        name={FieldNames.AccountStreet1}
        label={t("common:label.address1")}
        placeholder={t("common:placeholder.address")}
      />
      <TextInputFormik
        name={FieldNames.AccountStreet2}
        tooltipComponent={() => (
          <div className="ml-auto text-sm text-color-neutral-one">
            ({t("common:label.optional")})
          </div>
        )}
        label={t("common:label.address2")}
      />
      <div className="flex gap-5">
        <TextInputFormik
          name={FieldNames.AccountCity}
          placeholder={t("common:placeholder.city")}
          label={t("common:label.city")}
          className="flex-1 md:grow-[2]"
        />
        <TextInputFormik
          name={FieldNames.AccountPostalCode}
          placeholder={t("common:placeholder.zipPostCode")}
          label={t("common:label.zipPostCode")}
          className="flex-1"
        />
      </div>
      <SelectFormik
        name={FieldNames.AccountCountry}
        label={t("common:label.country")}
        placeholder={t("common:placeholder.select")}
        options={countries}
        searchableBySearchbox
      />
      {isRequiredProvince && (
        <SelectFormik
          name={FieldNames.AccountRegion}
          label={t("common:label.stateProvince")}
          placeholder={t("common:placeholder.selectStateProvince")}
          options={stateOptions.map((option) => ({
            ...option,
            label: option.name,
          }))}
          searchableBySearchbox
        />
      )}
    </>
  );
};

export default BillingAddressFormBlock;
